import actionTypes from "../constants/actionTypes";

export const toggleSettingsModal = (data) => ({
  type: actionTypes.TOGGLE_SETTINGS,
  payload: data,
});

